export const Enums: IEnums = {
  auditType: {
    retailer: 1,
    user: 2,
  },
  cacheKeys: {
    authorizationData: 'authorizationData',
    configSettings: 'configSettings',
    entityCache: 'entityCacheService',
    languageData: 'languageData',
    translationData: 'translationData',
  },
  dashboardDataLevel: {
    national: 1,
    region: 2,
    zone: 3,
    district: 4,
    dealer: 5,
  },
  dashboardSegment: {
    inbound: 'inbound',
    outbound: 'outbound',
  },
  dateModes: {
    currentMonth: { dateModeId: 1, displayName: 'Current Month' },
    lastThirtyDays: { dateModeId: 2, displayName: 'Last 30 Days' },
    lastMonth: { dateModeId: 3, displayName: 'Last Month' },
    previousThreeMonths: { dateModeId: 4, displayName: 'Prev. 3 Months' },
    selectedMonth: { dateModeId: 5, displayName: 'Selected Month' },
    custom: { dateModeId: 6, displayName: 'Custom Range' },
    previousTwelveMonths: { dateModeId: 7, displayName: 'Last 12 Months' },
    today: { dateModeId: 8, displayName: 'Today' },
    yesterday: { dateModeId: 9, displayName: 'Yesterday' },
  },
  detailsTab: {
    retailerHistory: 'Retailer History',
    retailerNotes: 'Retailer Notes',
    retailerPrograms: 'Retailer Programs',
    retailerPhoneNumbers: 'Retailer Phone Numbers',
    retailerHierarchy: 'Retailer Hierarchy',
  },
  keyCodes: {
    backspace: 8,
    tab: 9,
    enter: 13,
    esc: 27,
    space: 32,
    pageup: 33,
    pagedown: 34,
    end: 35,
    home: 36,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    insert: 45,
    del: 46,
  },
  language: {
    english: 1,
    englishCode: 'en-US',
    french: 2,
    frenchCode: 'fr-CA',
  },
  loginResult: {
    loginSuccess: 1,
    loginFailure: 2,
    logoutSuccess: 3,
  },
  menuType: {
    compact: 'compact',
    default: 'default',
    mini: 'mini',
  },
  modalSize: {
    small: 'smModal',
    smallMedium: 'smMdModal',
    medium: 'mdModal',
    large: 'lgModal',
    extraLarge: 'xlModal',
    notes: 'notesModal',
    wizard: 'wizardModal',
  },
  outboundKpis: {
    campaignSize: 'campaignSize',
    liveConnections: 'liveConnections',
    appointments: 'appointments',
    messages: 'voicemails',
  },
  outboundKpiDateType: {
    dashboardTimePeriod: 'Dashboard Time Period',
    last12Months: 'Last 12 Months',
  },
  program: {
    inboundService: 1,
    recallConcierge: 2,
    connectedServices: 5,
  },
  programStatus: {
    active: 1,
    inactive: 2,
  },
  role: {
    shiftAdmin: 'Shift Admin',
    shiftAnalyst: 'Shift Analyst',
    conciergeManager: 'Concierge Manager',
    conciergeAgent: 'Concierge Agent',
    retailerManager: 'Retailer Manager',
    retailerRepresentative: 'Retailer Representative',
    corporate: 'Corporate',
  },
  userType: {
    national: 1,
    region: 2,
    district: 3,
    dealer: 4,
    zone: 5,
  },
  viewType: {
    grid: 'grid',
    list: 'list',
  },
};

export interface IEnums {
  auditType: IAuditTypeEnum;
  cacheKeys: ICacheKeysEnum;
  dashboardDataLevel: IDashboardDataLevelEnum;
  dashboardSegment: IDashboardSegmentEnum;
  dateModes: IDateModeEnum;
  detailsTab: IDetailsTabEnum;
  keyCodes: IKeyCodesEnum;
  language: ILanguageEnum;
  loginResult: ILoginResultEnum;
  menuType: IMenuTypeEnum;
  modalSize: IModalSizeEnum;
  outboundKpis: IOutboundKpisEnum;
  outboundKpiDateType: IOutboundKpiDateTypeEnum;
  program: IProgramEnum;
  programStatus: IProgramStatus;
  role: IRoleEnum;
  userType: IUserTypeEnum;
  viewType: IViewTypeEnum;
}

export interface IAuditTypeEnum {
  retailer: number;
  user: number;
}

export interface ICacheKeysEnum {
  authorizationData: string;
  configSettings: string;
  entityCache: string;
  languageData: string;
  translationData: string;
}

export interface IDashboardDataLevelEnum {
  national: number;
  region: number;
  district: number;
  dealer: number;
  zone: number;
}

export interface IDashboardSegmentEnum {
  inbound: string;
  outbound: string;
}

export interface IDateMode {
  dateModeId: number;
  displayName: string;
}

export interface IDateModeEnum {
  currentMonth: IDateMode;
  lastThirtyDays: IDateMode;
  lastMonth: IDateMode;
  previousThreeMonths: IDateMode;
  previousTwelveMonths: IDateMode;
  selectedMonth: IDateMode;
  custom: IDateMode;
  today: IDateMode;
  yesterday: IDateMode;
}

export interface IDetailsTabEnum {
  retailerHistory: string;
  retailerNotes: string;
  retailerPrograms: string;
  retailerPhoneNumbers: string;
  retailerHierarchy: string;
}

export interface IKeyCodesEnum {
  backspace: number;
  tab: number;
  enter: number;
  esc: number;
  space: number;
  pageup: number;
  pagedown: number;
  end: number;
  home: number;
  left: number;
  up: number;
  right: number;
  down: number;
  insert: number;
  del: number;
}

export interface ILanguageEnum {
  english: number;
  englishCode: string;
  french: number;
  frenchCode: string;
}

export interface ILoginResultEnum {
  loginSuccess: number;
  loginFailure: number;
  logoutSuccess: number;
}

export interface IMenuTypeEnum {
  compact: string;
  default: string;
  mini: string;
}

export interface IModalSizeEnum {
  small: string;
  smallMedium: string;
  medium: string;
  large: string;
  extraLarge: string;
  wizard: string;
  notes: string;
}

export interface IOutboundKpisEnum {
  campaignSize: string;
  liveConnections: string;
  appointments: string;
  messages: string;
}

export interface IOutboundKpiDateTypeEnum {
  dashboardTimePeriod: string;
  last12Months: string;
}

export interface IProgramEnum {
  inboundService: number;
  recallConcierge: number;
  connectedServices: number;
}

export interface IProgramStatus {
  active: number;
  inactive: number;
}

export interface IRoleEnum {
  shiftAdmin: string;
  shiftAnalyst: string;
  conciergeManager: string;
  conciergeAgent: string;
  retailerManager: string;
  retailerRepresentative: string;
  corporate: string;
}

export interface IShopStatusEnum {
  ready: number;
  started: number;
  completed: number;
  canceled: number;
  creating: number;
  completing: number;
  agentCompleted: number;
}

export interface IUserTypeEnum {
  national: number;
  region: number;
  district: number;
  dealer: number;
  zone: number;
}

export interface IViewTypeEnum {
  grid: string;
  list: string;
}
